// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__13MD_","toolbar__select":"styles_toolbar__select__3wzos"};